import { Routes } from '@angular/router';
import {
  anonymousGuard,
  AuthenticationGuard,
  AuthenticationErrorComponent,
} from '@libs/authentication';
import { SAJ_PAGE_TITLES } from '@libs/types/navigation';

export const AppRoutes: Routes = [
  // Mount Authentication Module into the App
  {
    path: 'auth',
    loadChildren: () =>
      import('@libs/authentication').then((m) => m.SnagAuthenticationModule),
  },
  // After a successful Auth, where should the user be redirected to?
  // This is lifted out of the Auth module so the parent app can have control
  // over where to land the user.
  {
    path: 'login-success',
    redirectTo: 'recruiting',
    pathMatch: 'full',
  },

  // App Modules
  {
    path: 'recruiting',
    loadChildren: () =>
      import('./modules/recruiting').then((m) => m.AppRecruitingModule),
    canActivateChild: [AuthenticationGuard],
  },
  {
    path: 'business',
    loadChildren: () =>
      import('./modules/business').then((m) => m.AppBusinessModule),
    canActivateChild: [AuthenticationGuard],
  },
  {
    path: 'spotlight',
    loadChildren: () =>
      import('./modules/spotlight').then((m) => m.AppSpotlightModule),
    canActivateChild: [AuthenticationGuard],
  },
  {
    path: 'profile',
    loadChildren: () =>
      import('./modules/profile').then((m) => m.AppProfileModule),
    canActivateChild: [AuthenticationGuard],
    title: SAJ_PAGE_TITLES.Profile,
  },
  {
    path: 'legal',
    loadChildren: () =>
      import('./modules/pact-safe').then((m) => m.AppPactSafeModule),
  },
  {
    path: 'self',
    loadChildren: () =>
      import('./modules/registration').then((m) => m.AppRegistrationModule),
    canActivateChild: [anonymousGuard],
  },
  {
    path: 'register',
    loadComponent: () =>
      import('@libs/registration').then((m) => m.RegistrationPageComponent),
    loadChildren: () =>
      import('@libs/registration').then((m) => m.RegistrationRoutes),
    canActivate: [anonymousGuard],
  },
  {
    // Bespoke Phase 1 partner marketing landing pages: /partnership/<slug>.
    // Reuses the registration shell (nav) and lazy-loads the partnership
    // routes. The CTA links into /register with template + ref params.
    path: 'partnership',
    loadComponent: () =>
      import('@libs/registration').then((m) => m.RegistrationPageComponent),
    loadChildren: () =>
      import('@libs/registration').then((m) => m.PartnershipRoutes),
    canActivate: [anonymousGuard],
  },
  {
    path: 'applicant-tracking',
    loadChildren: () =>
      import('./modules/applicant-tracking').then(
        (m) => m.AppApplicantTrackingModule,
      ),
    canActivateChild: [anonymousGuard],
  },
  {
    path: 'unsubscribe/:id/:notificationType',
    loadChildren: () =>
      import('./modules/unsubscribe').then((m) => m.AppUnsubscribeModule),
  },
  {
    path: 'multi-filter',
    loadChildren: () =>
      import('@libs/multi-filter').then((m) => m.SAJMultiFilterModule),
  },
  {
    path: 'landing-page',
    loadChildren: () =>
      import('@libs/landing-pages').then((m) => m.LandingPagesModule),
  },
  {
    path: '404',
    component: AuthenticationErrorComponent,
    data: { error: 404 },
  },
  {
    path: '**',
    redirectTo: '404',
  },
  // default route
  {
    path: '',
    redirectTo: 'auth',
    pathMatch: 'full',
  },
];
